// extracted by mini-css-extract-plugin
export default {"footer_wrap":"footer_footer_wrap__0ezPM","footer_container":"footer_footer_container__qj30b"};